import {StyleSheet} from 'react-native';

import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  gutter: {
    width: '100%',
  },
  wrapper: {
    backgroundColor: white,
  },
});
